import { TemplateResult, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import innerStyles from './outline-kyruus-search-block.inner.pcss?inline';
import globalStyles from './outline-kyruus-search-block.global.pcss?inline';
import { AdoptedStyleSheets } from '../../../controllers/adopted-stylesheets';

/**
 * The Kyruus Search Block Component
 * @element outline-kyruus-search-block
 * @slot - Default slot to accept any content
 *
 * @todo
 * We use the outline-grid component for layout purposes within this. We should replace it, probably with some CSS in this component.
 */
@customElement('outline-kyruus-search-block')
export class OutlineKyruusSearchBlock extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: innerStyles,
  });

  render(): TemplateResult {
    return html` <slot></slot> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-kyruus-search-block': OutlineKyruusSearchBlock;
  }
}
